import { languageService } from "../../../../Language/language.service";

export const hosLocationsTableSchema = [
  {
    Header: languageService("Description"),
    accessor: "opt2.description",
    id: "description",
    minWidth: 150,
  },
  {
    Header: languageService("City"),
    accessor: "opt2.city",
    id: "city",
    minWidth: 150,
  },
  {
    Header: languageService("State"),
    accessor: "opt2.state",
    id: "state",
    minWidth: 100,
  },
  {
    Header: languageService("Division"),
    accessor: "opt2.division",
    id: "division",
    minWidth: 100,
  },
  {
    Header: languageService("Sub-Division"),
    accessor: "opt2.subdivision",
    id: "subdivision",
    minWidth: 100,
  },
];



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosLocationManager/schemas/hosLocationsTableSchema.js